import { render, staticRenderFns } from "./PhoneIcon.vue?vue&type=template&id=5f7eef2e&scoped=true&"
import script from "./PhoneIcon.vue?vue&type=script&lang=js&"
export * from "./PhoneIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7eef2e",
  null
  
)

export default component.exports